"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    // ======================================================
    notFoundPage: {
      message: 'A termék vagy az oldal nem található vagy nincs hozzá engedélye.'
    },
    loginPage: {
      title: 'Sprinx CRM belépés',
      username: 'felhasználó név',
      password: 'jelszó',
      loginButton: 'belépés'
    },
    loginErrorPage: {
      title: 'sikertelen belépés',
      error: 'Sikertelen belépés. Felhasználó név vagy jelszó nem található.',
      pleaseRelogin: 'Úgy tűnik nincs hitelesítve.Kérem hitelesítse magát újra.'
    },
    oauthLogin: {
      message: 'Be kell jelentkeznie. Krem válasszon egyet a listában szereplő hitelesítő szolgáltatók közül',
      loginButton: 'Belépés a Sprinx- szel',
      redirecting: 'Várakozás a hitelesítő szerverre történő átirányításra...'
    },
    logout: {
      inProgress: 'kijelentkezés...',
      error: 'kijelentkezési hiba',
      gotoHome: 'irányíts haza',
      success: 'sikeresen kijelentkezett.'
    }
  }
};
var _default = messages;
exports.default = _default;